import DynamicIcon, { IconName } from '@/components/DynamicIcon'
import { Topic } from '@/payload-types'
import { badgeColorMap } from '@/utilities/badgeColorMap'
import { kebabToCamel } from '@/utilities/toCamel'
import { cn } from '@/utilities/ui'

export default function TopicContent({ topics }: { topics: Topic[] }) {
  return (
    <div className="p-2">
      <h3 className="mb-2 font-family-body text-base font-semibold">Topics</h3>
      <div className="flex flex-col gap-2">
        {topics.map((topic) => {
          const topicColor = kebabToCamel(topic.color || 'evergreen')

          return (
            <div
              key={topic.id}
              className={cn(
                'flex items-center gap-2 rounded-2xl border px-3 py-1 font-body text-sm font-medium',
                badgeColorMap[topicColor].bg,
                badgeColorMap[topicColor].text,
                badgeColorMap[topicColor].border,
              )}
            >
              <DynamicIcon name={topic.icon as IconName} className="size-4" />
              {topic.title}
            </div>
          )
        })}
      </div>
    </div>
  )
}
